export default "__VITE_ASSET__6db3495d__"